<template>
    <div>
        <transition name="fade">
            <div
                v-show="flgCantEnterTime"
                class="alert alert-warning"
                :class="{ 'is-display-other-alert' : isDisplayOtherAlert === true }">
                <div class="d-flex justify-content-between align-items-center">
                    <div>{{ cantEnterTimeMessage }}</div>
                    <div class="btn-close" @click="reset">
                        <span>&times;</span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default  {
        data: function() {
            return {
                flgCantEnterTime: false,
                cantEnterTimeMessage: '',
                timer: null,
                isDisplayOtherAlert: false,
            };
        },

        created: function() {
            bus.$on('alert-cant-enter-time', this.alertCantEnterTime)
            bus.$on('toggle-display-other-alert', this.toggleDisplayOtherAlert)
        },

        beforeDestroy: function() {
            bus.$off('alert-cant-enter-time')
            bus.$off('toggle-display-other-alert')
        },

        methods: {
            /**
             * 入室可能時間の終了5分前アラートの表示
             *
             * @param {string} message
             * @param {number} milliseconds
             */
            alertCantEnterTime: function (message, milliseconds) {
                this.reset()

                this.flgCantEnterTime = true
                this.cantEnterTimeMessage = message

                this.resetDelay(milliseconds)
            },

            /**
             * フラグリセット
             */
            reset: function() {
                this.flgCantEnterTime = false
            },

            /**
             * 遅延フラグリセット
             *
             * @param {number} milliseconds
             */
            resetDelay: function (milliseconds = 3000) {
                if (Number.isInteger(milliseconds)) {
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => this.reset(), milliseconds)
                }
            },

            /**
             * 他のアラートが同時に表示されているかどうかのフラグを切り替え
             *
             * @param {boolean} param
             */
            toggleDisplayOtherAlert: function (param) {
                this.isDisplayOtherAlert = param
            },
        },
    }
</script>

<style scoped lang="scss">
    .alert {
        position: fixed;
        left: 50%;
        top: 20px;
        z-index: 9999;
        width: 80vw;
        transform: translate( -50%, 0 );
        opacity: 1;

        &.is-display-other-alert {
            position: fixed;
            left: 50%;
            top: 72px;
        }
    }

    .btn-close {
        position: relative;
        width: 20px;
        height: 20px;
        min-width: 20px;
        color: #fff;
        line-height: 20px;
        font-weight: bold;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
    }

    .alert-success {
        .btn-close {
            background: #155724;
        }
    }

    .alert-danger {
        .btn-close {
            background: #721c24;
        }
    }

    .alert-warning {
        .btn-close {
            background: #856404;
        }
    }

    .alert-info {
        .btn-close {
            background: #0c5460;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
